export enum PortfolioConfigName {
    PortfolioAccountTransactions = 'PortfolioAccountTransactions',
    PortfolioPositions = 'PortfolioPositions',
    PortfolioStandingOrders = 'PortfolioStandingOrders',
    PortfolioTransactions = 'PortfolioTransactions',
}
